<!--eslint-disable vue/no-v-html-->
<template>
    <component
        :is="tag"
        v-if="plainText"
        v-html="getHtmlBlock"
    />
</template>

<script>
export default {
    name: 'BlockHtml',
    props: {
        /**
         * Text to be rendered
         */
        plainText: {
            type: String,
            default: '',
        },
        /**
         * Tag
         */
        tag: {
            type: String,
            default: 'div',
        },
    },
    computed: {
        /**
         * Get plain HTML
         * @return {string} - Plain HTML
         */
        getHtmlBlock() {
            const { plainText } = this;

            return plainText.replace(/<script[^>]*>.*<\/script>/g, '');
        },
    },
};
</script>
